import React from "react";
import Blog_50_3 from "../component/Blog_50_3";
function Blog_50_3_container() {
  return <Blog_50_3 />;
}

export default Blog_50_3_container;
